var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-editor"},[_c('WidgetSelector',{attrs:{"main-widget":_vm.mainWidget,"options":_vm.options},on:{"select":function (widget) { return _vm.$emit('change-widget', widget); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }